import React, { useEffect, useState, Fragment } from 'react';
import { BookOpen, Trophy, Star, Lock, Zap, ShieldCheck, CreditCard, ArrowRight } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
const plans = [{
  id: 'pack',
  icon: BookOpen,
  name: 'PÁDEL MASTER PACK',
  detail: '6 tomos + 6 bonos exclusivos',
  oldPrice: '$34.990',
  price: '$19.990',
  badge: null,
  save: null,
  checkoutUrl: 'https://checkout.tusbeneficios.shop/cart/51152409362665:1'
}, {
  id: 'elite',
  icon: Trophy,
  name: 'PACK PRO ÉLITE',
  detail: '6 tomos + 6 bonos + Asesoría Pro Élite',
  oldPrice: '$43.990',
  price: '$27.990',
  badge: 'MÁS ELEGIDO',
  save: 'AHORRÁS $16.000',
  checkoutUrl: 'https://checkout.tusbeneficios.shop/cart/51152418537705:1'
}];
export function Oferta() {
  const [timeLeft, setTimeLeft] = useState(24 * 60 * 60);
  const [selected, setSelected] = useState('elite');
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const h = Math.floor(timeLeft / 3600);
  const m = Math.floor(timeLeft % 3600 / 60);
  const s = timeLeft % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  const timeBlocks = [{
    value: pad(h),
    label: 'HORAS'
  }, {
    value: pad(m),
    label: 'MIN'
  }, {
    value: pad(s),
    label: 'SEG'
  }];
  return <section id="oferta" className="py-16 bg-padel-dark relative border-t border-neon/30" data-id="element-149">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-neon/5 blur-[120px] rounded-full pointer-events-none" data-id="element-150"></div>

      <div className="container mx-auto px-4 max-w-2xl relative z-10" data-id="element-151">
        <FadeIn data-id="element-152">
          {/* Countdown */}
          <p className="text-center text-neon font-display font-bold uppercase tracking-widest text-sm mb-4" data-id="element-153">
            ⏱ Esta oferta termina en
          </p>
          <div className="flex justify-center gap-3 mb-10" data-id="element-154">
            {timeBlocks.map((b, idx) => <Fragment key={b.label} data-id="element-155">
                <div className="bg-padel-blue border border-white/10 rounded-xl w-20 py-3 text-center" data-id="element-156">
                  <div className="font-display font-bold text-3xl md:text-4xl text-white tabular-nums" data-id="element-157">
                    {b.value}
                  </div>
                  <div className="text-[10px] text-gray-400 tracking-widest mt-1" data-id="element-158">
                    {b.label}
                  </div>
                </div>
                {idx < timeBlocks.length - 1 && <span className="font-display font-bold text-3xl text-neon self-center" data-id="element-159">
                    :
                  </span>}
              </Fragment>)}
          </div>

          {/* Title */}
          <h2 className="font-display text-3xl md:text-4xl font-bold text-center uppercase mb-2" data-id="element-160">
            Elegí tu <span className="text-neon" data-id="element-161">acceso</span>
          </h2>
          <p className="text-center text-gray-400 mb-8" data-id="element-162">
            Ambas opciones incluyen los 6 bonos exclusivos completos
          </p>

          {/* Plans */}
          <div className="space-y-4 mb-8" data-id="element-163">
            {plans.map(plan => {
            const isActive = selected === plan.id;
            return <button key={plan.id} onClick={() => setSelected(plan.id)} aria-pressed={isActive} className={`w-full text-left rounded-2xl p-5 border-2 transition-all relative ${isActive ? 'border-neon bg-neon/5 shadow-[0_0_25px_rgba(198,255,0,0.12)]' : 'border-white/10 bg-padel-blue/60 hover:border-white/25'}`} data-id="element-164">
                  <div className="flex items-start gap-4" data-id="element-165">
                    {/* Radio */}
                    <span className={`mt-1 w-5 h-5 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${isActive ? 'border-neon' : 'border-gray-500'}`} data-id="element-166">
                      {isActive && <span className="w-2.5 h-2.5 rounded-full bg-neon" data-id="element-167" />}
                    </span>

                    <div className="flex-1 min-w-0" data-id="element-168">
                      <div className="flex items-center gap-2 mb-1" data-id="element-169">
                        <plan.icon className="w-5 h-5 text-neon flex-shrink-0" data-id="element-170" />
                        <span className="font-display font-bold text-lg md:text-xl uppercase" data-id="element-171">
                          {plan.name}
                        </span>
                      </div>

                      {(plan.badge || plan.save) && <div className="flex flex-wrap gap-2 mb-2" data-id="element-172">
                          {plan.badge && <span className="inline-flex items-center gap-1 bg-neon text-black text-[11px] font-bold uppercase px-2 py-0.5 rounded" data-id="element-173">
                              <Star className="w-3 h-3 fill-current" data-id="element-174" />{' '}
                              {plan.badge}
                            </span>}
                          {plan.save && <span className="inline-flex items-center bg-green-500/20 text-green-400 text-[11px] font-bold uppercase px-2 py-0.5 rounded" data-id="element-175">
                              {plan.save}
                            </span>}
                        </div>}

                      <p className="text-gray-400 text-sm" data-id="element-176">{plan.detail}</p>
                    </div>

                    {/* Price */}
                    <div className="text-right flex-shrink-0" data-id="element-177">
                      <div className="text-gray-500 text-sm line-through" data-id="element-178">
                        {plan.oldPrice}
                      </div>
                      <div className="text-neon font-display font-bold text-2xl md:text-3xl" data-id="element-179">
                        {plan.price}
                      </div>
                    </div>
                  </div>
                </button>;
          })}
          </div>

          {/* CTA */}
          <Button fullWidth className="py-5 text-lg md:text-xl" onClick={() => {
          const plan = plans.find(p => p.id === selected);
          if (plan?.checkoutUrl) {
            window.location.href = plan.checkoutUrl;
          }
        }} data-id="element-180">
            SÍ, QUIERO ACCEDER AHORA <ArrowRight className="w-6 h-6" data-id="element-181" />
          </Button>

          <p className="text-center text-gray-500 text-sm italic mt-4" data-id="element-182">
            La opción más elegida por quienes buscan resultados reales en la
            cancha
          </p>

          <div className="border-t border-white/10 mt-8 pt-6" data-id="element-183">
            <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-gray-300" data-id="element-184">
              <span className="flex items-center gap-1.5" data-id="element-185">
                <Lock className="w-4 h-4 text-neon" data-id="element-186" /> Pago seguro
              </span>
              <span className="flex items-center gap-1.5" data-id="element-187">
                <Zap className="w-4 h-4 text-neon" data-id="element-188" /> Acceso inmediato
              </span>
              <span className="flex items-center gap-1.5" data-id="element-189">
                <ShieldCheck className="w-4 h-4 text-neon" data-id="element-190" /> Garantía 7 días
              </span>
            </div>
            <div className="flex items-center justify-center gap-1.5 text-sm text-gray-400 mt-3" data-id="element-191">
              <CreditCard className="w-4 h-4 text-neon" data-id="element-192" /> Mercado Pago ·
              Tarjetas · Astro Pay
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}